import { render, staticRenderFns } from "./sysStudentDetail.vue?vue&type=template&id=5b60ee86&scoped=true&"
import script from "./sysStudentDetail.vue?vue&type=script&lang=js&"
export * from "./sysStudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./sysStudentDetail.vue?vue&type=style&index=0&id=5b60ee86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60ee86",
  null
  
)

export default component.exports